var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "280"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "color": "white",
      "block": "",
      "tile": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("닫기")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }